import React from 'react';
import { AppBar, Toolbar, IconButton, Select, MenuItem, Tooltip } from '@material-ui/core';
import Icon from '@mdi/react';
import { mdiFormatFontSizeDecrease, mdiFormatFontSizeIncrease, mdiLightbulb, mdiLightbulbOutline } from '@mdi/js';
import { withStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/styles';
import FormControl from '@material-ui/core/FormControl';
import { Link } from 'react-router-dom';
const AdapterLink = React.forwardRef((props, ref) => React.createElement(Link, Object.assign({ innerRef: ref }, props)));
const styles = theme => ({
    root: {
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
    },
    spacer: {
        flexGrow: 1
    },
    whiteText: {
        color: theme.palette.text
    }
});
const useStyles = makeStyles(theme => ({
    formControl: {
        marginRight: theme.spacing(2),
        minWidth: 120,
    }
}));
function ModeDropdown(props) {
    const classes = useStyles();
    const [values, setValues] = React.useState({
        mode: props.activeItem,
        selectedText: 'metamorphosis'
    });
    function handleChange(event) {
        setValues(oldValues => ({
            ...oldValues,
            [event.target.name]: event.target.value
        }));
        if (event.target.name === 'mode') {
            modeHandler(event.target.value);
        }
        if (event.target.name === 'selectedText') {
            longTextHandler(event.target.value);
        }
    }
    const { modeHandler, longTextHandler } = props;
    return (React.createElement("form", { autoComplete: 'off' },
        React.createElement(FormControl, { className: classes.formControl },
            React.createElement(Select, { value: values.mode, onChange: handleChange, inputProps: {
                    name: 'mode',
                    id: 'modePicker'
                } },
                React.createElement(MenuItem, { value: 'practice', component: AdapterLink, to: '/practice' }, "Random Words"),
                React.createElement(MenuItem, { value: 'smartExercise', component: AdapterLink, to: '/smart-exercise' }, "Smart Exercise"),
                React.createElement(MenuItem, { value: 'speedTest', component: AdapterLink, to: '/speed-test' }, "Speed Test"))),
        values.mode === 'longText' ?
            React.createElement(FormControl, { className: classes.formControl },
                React.createElement(Select, { value: values.selectedText, onChange: handleChange, inputProps: {
                        name: 'selectedText',
                        id: 'selectLongText'
                    } },
                    React.createElement(MenuItem, { value: 'metamorphosis' }, "The Metamorphosis"),
                    React.createElement(MenuItem, { value: 'aliceInWonderland' }, "Alice in Wonderland"),
                    React.createElement(MenuItem, { value: 'tomSawyer' }, "The Adventures of Tom Sawyer")))
            :
                ''));
}
function AppMenu(props) {
    const theme = useTheme();
    const { zoomHandler, modeHandler, longTextHandler, classes, activeItem, longText, setDarkTheme } = props;
    const darkTheme = theme.palette.type === 'dark';
    return (React.createElement(AppBar, { position: 'static', className: classes.root, elevation: 2 },
        React.createElement(Toolbar, { variant: 'dense' },
            React.createElement(ModeDropdown, Object.assign({}, props)),
            React.createElement("div", { className: classes.spacer }),
            React.createElement(Tooltip, { title: 'Toggle dark theme' },
                React.createElement(IconButton, { name: 'darkMode', onClick: () => setDarkTheme(!darkTheme) },
                    React.createElement(Icon, { path: darkTheme ? mdiLightbulb : mdiLightbulbOutline, color: darkTheme ? '#fff' : '#000', size: 1 }))),
            React.createElement(Tooltip, { title: 'Increase font size' },
                React.createElement(IconButton, { name: 'zoom in', onClick: () => zoomHandler('zoomIn') },
                    React.createElement(Icon, { color: darkTheme ? '#fff' : '#000', path: mdiFormatFontSizeIncrease, size: 1 }))),
            React.createElement(Tooltip, { title: 'Decrease font size' },
                React.createElement(IconButton, { edge: 'end', name: 'zoom out', onClick: () => zoomHandler('zoomOut') },
                    React.createElement(Icon, { path: mdiFormatFontSizeDecrease, color: darkTheme ? '#fff' : '#000', size: 1 }))))));
}
export default withStyles(styles)(AppMenu);
//# sourceMappingURL=AppMenu.js.map